import api from '../api.js';
import { notify } from '../../versa/msgbox.js';
import * as types from '../types.js';

function lockoutExpirationIso() {
	const d = new Date();
	d.setDate(d.getDate() + 30);
	return d.toISOString();
}

export default {

	html: `
		<style>
			#user #id				{ width: 20rem;		}
			#user #name				{ width: 20rem;		}
			#user #email			{ width: 20rem;		}
			#user #phone			{ width: 10rem;		}
			#user #username			{ width: 10rem; 	}
			#user #user_status		{ width: 10rem;		}
		</style>
		<form id="user" class="form" autocomplete="off">
			<div class="fsb">
				<label title="Status do usuário no sistema">Status
					<input id="user_status" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Identificador do usuário">Usuário
					<input id="id" type="text" disabled>
				</label>
				<label title="Usuário de acesso ao sistema">Username<sup>*</sup>
					<input id="username" type="text" required>
				</label>
				<label title="Telefone com DDI e DDD">Telefone
					<input id="phone" type="text" placeholder="+00 (00) 0000-0000">
				</label>
			</div>
			<div class="fsb">
				<label title="Nome do usuário">Nome<sup>*</sup>
					<input id="name" type="text" required>
				</label>
				<label title="Email">Email
					<input id="email" type="text">
				</label>
			</div>
			<div class="fsb">
				<label class="keymap">Grupos<sup>*</sup>
					<select id="groups" multiple size="4" required>
					</select>
				</label>
				<span class="keymap">
					<button class="bn_Left" title="Incluir grupos selecionados à direita"> &#x1F844;</button>
					<button class="bn_Right" title="Remover grupos selecionados à esquerda">&#x1F846;</button>
				</span>
				<label class="keymap">Disponíveis
					<select id="available" multiple size="4">
					</select>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
					<button type="button" class="button bn_user_disable" title="Impede login até reativar">Inativar</button>
					<button type="button" class="button bn_user_enable" title="Permite login novamente">Ativar</button>
					<button type="button" class="button bn_user_block" title="Bloqueia login temporariamente">Bloquear</button>
					<button type="button" class="button bn_user_unblock" title="Remove bloqueio">Desbloquear</button>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#user',
		init(formset) {
			const root = () => formset.dialog?.getNode?.();
			const formEl = () => root()?.querySelector?.('#user');
			const getId = () => formEl()?.querySelector?.('#id')?.value;
			const setStatus = (s) => { const el = formEl()?.querySelector?.('#user_status'); if (el) el.value = s; };
			const doAction = async (payload, statusLabel) => {
				const id = getId();
				if (!id) return;
				const resp = await api.call(api.update_user, id, payload);
				// http retorna true ou body em sucesso; undefined em falha (nunca retorna Response)
				if (resp != null) setStatus(statusLabel);
				else notify('Falha ao atualizar usuário.', 'Usuários');
			};
			// Delegação no dialog para garantir que o clique dispare o PATCH (evita interceptação pelo dialog)
			const dialogNode = root();
			if (dialogNode) {
				dialogNode.addEventListener('click', (ev) => {
					const t = ev.target?.closest?.('.bn_user_disable');
					if (t) { ev.preventDefault(); ev.stopPropagation(); doAction({ is_disabled: true }, 'Inativo'); return; }
					const e = ev.target?.closest?.('.bn_user_enable');
					if (e) { ev.preventDefault(); ev.stopPropagation(); doAction({ is_disabled: false }, 'Ativo'); return; }
					const b = ev.target?.closest?.('.bn_user_block');
					if (b) { ev.preventDefault(); ev.stopPropagation(); doAction({ lockout_expiration: lockoutExpirationIso() }, 'Bloqueado'); return; }
					const u = ev.target?.closest?.('.bn_user_unblock');
					if (u) { ev.preventDefault(); ev.stopPropagation(); doAction({ lockout_expiration: null }, 'Ativo'); return; }
				});
			}
			Object.getPrototypeOf(this).init?.call(this, formset);
		},
	},
	
	fields: [
		{ properties: { selector: '#user_status' }, types: [] },
		{ properties: { selector: '#id' }, types: [] },
		{ properties: { selector: '#name' }, types: [types.name()] },
		{ properties: { selector: '#email' }, types: [types.email()] },
		{ properties: { selector: '#phone' }, types: [types.phone()] },
		{ properties: { selector: '#username' }, types: [types.username()] },
		{ properties: { selector: '#groups' }, types: [types.keymap('groups', '#available'), types.km_fill()] },
	]

};

